export const BuildInfo = {timestamp:1771611677000}
